import { mapList, mapDetail, mapRelated } from "./apiMapper";

export const BASE_URL =
  process.env.REACT_APP_API_BASE_URL ?? "http://localhost:8787";

const fetcher = (path, options = {}) =>
  fetch(`${BASE_URL}${path}`, options).then((res) => {
    if (!res.ok && res.status === 404) throw new Error("not_found");
    if (!res.ok) throw new Error(`request_failed:${res.status}`);
    return res.json();
  });

export const listProducts = (params = {}) => {
  const qs = new URLSearchParams(params).toString();
  return fetcher(`/api/products${qs ? `?${qs}` : ""}`).then(mapList);
};

export const getProductDetail = (id) =>
  fetcher(`/api/products/${id}`).then(mapDetail);

export const getProductRelated = (id, limit = 4) =>
  fetcher(`/api/products/${id}/related?limit=${limit}`).then(mapRelated);

export const getAddons = (productId) =>
  fetcher(`/api/addons?productId=${productId}`);

export const createCheckoutSession = (items) =>
  fetcher("/api/checkout/session", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ items }),
  });

export const createDirectOrder = (items, customer, paymentType = "CASH_ON_DELIVERY") =>
  fetcher("/api/orders/direct", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ items, customer, payment_type: paymentType }),
  });

export const getOrder = (orderId) => fetcher(`/api/orders/${orderId}`);

export const listOrders = (phone) =>
  fetcher(`/api/orders?phone=${encodeURIComponent(phone)}`);